import { SUPPORTED_LOCALES } from '@/i18n'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from '@/ui-kit/components/DropdownMenu'
import { useLocale } from '@/ui-kit/providers'
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import clsx from 'clsx'
import { Check, ChevronDown } from 'lucide-react'

export const LanguageSwitcher = ({ className }: { className?: string }) => {
  const { locale, setLocale, availableLocales } = useLocale()

  if (availableLocales.length < 2) return null

  const current = SUPPORTED_LOCALES[locale]

  return (
    <DropdownMenu>
      <DropdownMenuPrimitive.Trigger
        className={clsx(
          'text-body-2 flex h-10 cursor-pointer items-center gap-2 rounded-lg border border-solid border-gray-100 px-3 outline-0 transition-colors',
          'hover:border-orange data-[state=open]:border-gray-70 max-mobile:hidden',
          className
        )}
      >
        <span className="text-base leading-none">{current?.flag}</span>
        <ChevronDown className="text-gray-80 size-4 shrink-0 opacity-70" />
      </DropdownMenuPrimitive.Trigger>
      <DropdownMenuContent side="bottom" align="end" className="min-w-[12rem] p-1">
        {availableLocales.map((code) => (
          <DropdownMenuItem key={code} onSelect={() => setLocale(code)}>
            <span className="flex w-full items-center gap-3">
              <span className="text-base leading-none">{SUPPORTED_LOCALES[code]?.flag}</span>
              <span className="flex-1">{SUPPORTED_LOCALES[code]?.label ?? code}</span>
              {locale === code && <Check className="text-gray-70 size-4 shrink-0" />}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
